"use strict";

exports.__esModule = true;
exports.filterPlantStateActivities = void 0;
var _includes2 = _interopRequireDefault(require("ramda/src/includes"));
var _filter2 = _interopRequireDefault(require("ramda/src/filter"));
var _propEq2 = _interopRequireDefault(require("ramda/src/propEq"));
var _find2 = _interopRequireDefault(require("ramda/src/find"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var filterPlantStateActivities = exports.filterPlantStateActivities = function filterPlantStateActivities(plantStateActivities, config, allowProducing, plantStateActivitiesDevice, deviceUUId) {
  var filteredActivityIds = plantStateActivitiesDevice.activitiesDevices.filter(function (activity) {
    return activity.devices.length === 0 || activity.devices.includes(deviceUUId);
  }).map(function (activity) {
    return activity.id !== undefined ? activity.id : null;
  });
  var filteredActivities = filterPlantStateActivitiesDevices(plantStateActivities, filteredActivityIds);
  if (config) {
    var widgetList = config.element.children;
    var classificationButtonPanelWidget = (0, _find2["default"])((0, _propEq2["default"])("type", "ClassificationButtonPanel"))(widgetList);
    if (!classificationButtonPanelWidget) return filteredActivities;
    var plantStateIdsForContextMenu = classificationButtonPanelWidget.props.plantStateIds;
    var mapping = filteredActivities.mapping,
      states = filteredActivities.states;
    var newMapping = (0, _filter2["default"])(function (mapper) {
      return filterStates(mapper.stateId, plantStateIdsForContextMenu, allowProducing);
    }, mapping);
    var newStates = (0, _filter2["default"])(function (state) {
      return filterStates(state.id, plantStateIdsForContextMenu, allowProducing);
    }, states);
    return Object.assign({}, filteredActivities, {
      mapping: newMapping,
      states: newStates
    });
  }
  return filteredActivities;
};
function filterPlantStateActivitiesDevices(plantStateActivities, filteredActivityIds) {
  var filteredPlantStateActivities = Object.assign({}, plantStateActivities);
  if (Object.keys(filteredActivityIds).length === 0) {
    filteredPlantStateActivities.activities = [];
  } else {
    filteredPlantStateActivities.activities = filteredPlantStateActivities.activities.filter(function (activity) {
      return filteredActivityIds.includes(activity.id);
    });
  }
  filteredPlantStateActivities.mapping = filteredPlantStateActivities.mapping.map(function (mapping) {
    var newMapping = Object.assign({}, mapping);
    if (Object.keys(filteredActivityIds).length === 0) {
      newMapping.activities = [];
    } else {
      newMapping.activities = newMapping.activities.filter(function (activity) {
        return filteredActivityIds.includes(activity.id);
      });
    }
    return newMapping;
  });
  return filteredPlantStateActivities;
}
var filterStates = function filterStates(id, plantStateIdsForContextMenu, allowProducing) {
  // special case because device has a property allowProducing
  if (id === "producing") {
    return allowProducing;
  } else {
    return (0, _includes2["default"])(id, plantStateIdsForContextMenu);
  }
};